(function() {
    'use strict';

    var PARTIALURL = '/simplicity/partials/mnp';
    var CMS_MESSAGE_PARTIALS = '/api-static/errormessages';
    var APIBASEURL = '/api/commerce/';

    window.PARTIALURL = PARTIALURL; // workaround, config not available in routing config even if injected

    var mnp = angular.module('mnp.config', []);
    mnp.value('config', {
        apiURLs: {
            LOGIN: APIBASEURL + 'authstatus',
            LOGOUT: APIBASEURL + 'authstatus',
            MYVFLOGOUT: '/mint/rest/session/end',
            NBA: APIBASEURL + 'nba/mnp',
            BASKET: APIBASEURL + 'basket',
            CHECKOUT: APIBASEURL + 'basket/checkout',
            ORDER: APIBASEURL + 'order',
            ORDERSTATUSINPORT: APIBASEURL + 'orderStatusInport',
            PROVIDERLIST: APIBASEURL + 'provider',
            MOBILENUMBERCHECK: APIBASEURL + 'mobileNumberCheck',
            PORTINGORDEREXISTS: APIBASEURL + 'mobileNumberPortingOrderExists'

        },
        partialsBaseUrl: PARTIALURL,
        messagePartialURLs: {
            cmsBaseUrl: CMS_MESSAGE_PARTIALS + '/', // path to generated porting-status messages from cms (Page-ID: 422586)
            cmsFilePrefix: 'mnp-partial-status-', // file prefix for generated porting-status messages from cms
            internalErrors: {
                missingCredentials: PARTIALURL + '/status/messages/porting.status.missingCredentials.html',
                early: PARTIALURL + '/status/messages/porting.status.early.html',
                error: PARTIALURL + '/status/messages/porting.status.error.html',
            },
            // special ePos status messages from cms (Page-ID: 422586)
            messages: {
                uebermittelt: CMS_MESSAGE_PARTIALS + '/porting.status.uebermittelt.html',
                bonitaet: CMS_MESSAGE_PARTIALS + '/porting.status.bonitaet.html',
                manuell: CMS_MESSAGE_PARTIALS + '/porting.status.manuell.html',
                erledigt: CMS_MESSAGE_PARTIALS + '/porting.status.erledigt.html',
                export: CMS_MESSAGE_PARTIALS + '/porting.status.export.html',
                default: CMS_MESSAGE_PARTIALS + '/porting.status.default.html',
            },
        },
        COOKIESET: {
            BSHOPURL: APIBASEURL + 'setcookie/bshop',
            SELURL: APIBASEURL + 'setcookie/sel',
            HEADERFLAG: 'x-vf-bshoptoken-set'
        },
        MNPCOOKIE: {
            NAME: 'mnp',
            PATH: '/',
            TTL: 30
        },
        SELTOKEN: {
            URL: APIBASEURL + 'extAuthInt/oauth2/token'
        },
        isUrlApiUrl: function(url) {
            var result = false;
            $.each(this.apiURLs, function(i, e) {
                if (e === url) {
                    result = true;
                }
            });
            return result;
        },
        loginerrors: {
            '4012': 'Ihre Anmeldedaten waren nicht korrekt bitte wiederholen Sie Ihre Eingabe',
            '4013': 'Sie haben Ihre Daten zu oft falsch eingegeben, die Anmeldung wurde daher vor&uuml;bergehend gesperrt',
            '4014': 'Ihren Auftrag zur Rufnummern-Mitnahme k&ouml;nnen wir leider nicht bearbeiten. Daf&uuml;r gibt es 2 Gr&uuml;nde: Entweder ist Ihre Vodafone-Rufnummer gerade gesperrt. Oder Sie haben diese Rufnummer schon gek&uuml;ndigt.'
        },
        formErrors: {
            emailNotEqual: 'Bitte geben Sie die gleiche Email-Adresse ein.',
            emailNotValid: 'Bitte geben Sie eine gültige Email-Adresse ein.'
        },
        linkUrls: {
            status: {
                url: '/status-rufnummernmitnahme', // TODO: set correct URL prior release (CMS Page-ID: 419608)
                text: 'Zum Status Ihrer Rufnummern-Mitnahme'
            },
            common: {
                myVodafone: '/meinvodafone/services/',
            }
        },
        shopCredentials: {
            bId: '1793',
            shopId: '2655'
        },
        ndc: ['01501', '01502', '01505', '01508', '0151', '01520', '01521', '01522', '01523', '01525', '01526', '01529', '01531', '01551', '01555', '01556', '01563', '01566', '01567', '01570', '01573', '01575', '01577', '01578', '01579', '01588', '01590', '0160', '0162', '0163', '0170', '0171', '0172', '0173', '0174', '0175', '0176', '0177', '0178', '0179'],
        tracking: {
        	siteArea: 'mobility',
        	platformType: 'responsive',
        	pageType: 'self service',
        	siteStructure: [
            'Privatkunden',
            'Hilfe',
            'Service-Themen',
            'Rund ums Telefonieren',
            'Rufnummern-Mitnahme',
            'Rufnummer online mitnehmen',
            'Rufnummer online mitnehmen'
        ]
        }
    });
})();
